/**
 * Global light/dark mode toggle (spec: Operator design language, section 3).
 * One click switches the whole product between the Operator Dark /
 * Clean Enterprise Light pair. Mounted in the top bar and on the login page.
 */
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { useTranslation } from "react-i18next";
import { useThemeContext } from "@/theme";

export interface ThemeToggleButtonProps {
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
}

export function ThemeToggleButton({ size = "small", sx }: ThemeToggleButtonProps) {
  const { mode, toggleMode } = useThemeContext();
  const { t } = useTranslation();
  const label =
    mode === "dark"
      ? t("common.lightTheme", "Light theme")
      : t("common.darkTheme", "Dark theme");
  return (
    <Tooltip title={label}>
      <IconButton onClick={toggleMode} size={size} aria-label={label} sx={sx}>
        {mode === "dark" ? (
          <LightModeOutlinedIcon sx={{ fontSize: 18 }} />
        ) : (
          <DarkModeOutlinedIcon sx={{ fontSize: 18 }} />
        )}
      </IconButton>
    </Tooltip>
  );
}
